import { Badge } from './badge';
import { cn } from '@/lib/utils';
import { PacketStatus } from '@promo/shared';
import { getPacketStatusLabel } from '@/lib/packetStatus';

export function StatusBadge({ status, className }: { status: PacketStatus | string; className?: string }) {
  let variant: 'default' | 'secondary' | 'outline' | 'destructive' = 'secondary';
  
  switch (status) {
    case PacketStatus.DRAFT:
      variant = 'secondary';
      break;
    case PacketStatus.BLINDED_ASSESSMENT:
    case PacketStatus.UNBLINDED_ASSESSMENT:
    case PacketStatus.MANAGER_SUMMARY:
    case PacketStatus.SENIOR_LEADER_REVIEW:
    case PacketStatus.HR_REVIEW:
      variant = 'default'; // Active states use default/primary
      break;
    case PacketStatus.COMPLETED:
      variant = 'outline'; // Completed uses outline
      break;
    case PacketStatus.WITHDRAWN:
      variant = 'destructive'; // Withdrawn uses destructive (red)
      break;
    default:
      variant = 'outline'; // Fallback for unknown statuses
      break;
  }

  return (
    <Badge variant={variant} className={cn('capitalize', className)}>
      {getPacketStatusLabel(status)}
    </Badge>
  );
} 